import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableExternalLinksWLP from './tableExternalLinksWLP';

export default {
  title: 'External Links WLP',
  attributeName: 'externalLinks',
  helpText: '',
  getURL: 'appId/areaId/wlpExternalLinks',
  updateURL: 'appId/areaId/wlpExternalLinks',
  removeURL: 'appId/areaId/wlpExternalLinks',
  idAttribute: 'id',
  sessionParams: ['appId', 'areaId'],
  fields: [
    {
      attributeName: 'externalLinksTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode: 'NORMAL',
      helpText: '',
      configFile: tableExternalLinksWLP,
    },
    // {
    //   attributeName: 'externalLinks',
    //   type: FormInputTypes.TABLE,
    //   label: '',
    //   helpText: '',
    //   configFile: tableExternalLinksWLP,
    // },
  ],
};